import { Pipe, PipeTransform, Inject } from '@angular/core';
import { Lead } from 'src/app/core/models/lead/lead.model';
import { APP_CONFIG } from 'src/app/shared/configurations/configurations.factory';
import { Configurations } from 'src/app/shared/configurations/models/configurations.model';

@Pipe({
    name: 'businessName',
    standalone: false
})
export class BusinessNamePipe implements PipeTransform {

  constructor(@Inject(APP_CONFIG) protected readonly config: Configurations) {
  }

  transform(value: Lead): string {
    return value?.rawValues.find(rv => this.config.rawvaluesNamesConfig.businessName.includes(rv.description))?.value ?? ''
  }

}
